export default "cdb946956e4ff87f.svg"